import olympicMapper from './olympic-mapper'

export default {
  ...olympicMapper,
  quality: {
    'AB': "PREMIUM \n #2&BTR",
    'I-III r.': "PREMIUM \n #2&BTR",
    'I-III r. BS': "PREMIUM \n #2&BTR",
    'I-III r. W': "PREMIUM \n #2&BTR",
    'IV r.': "NORDIC\nINDUSTRIAL"
  }
}



// WEBPACK FOOTER //
// ./src/helpers/pdf-labels/nordic-mapper.js